import React from 'react'
import PropTypes from 'prop-types'

export default function ComingSoon({ label = 'PROXIMAMENTE' }) {
  return (
    <span className="inicio-coming-soon">
      <span className="inicio-coming-soon__dot" aria-hidden="true" />
      {label}
    </span>
  )
}

ComingSoon.propTypes = {
  label: PropTypes.string
}
